import notificationAPI from '../../api/Notification'
import * as types from '../mutation-types'

// STATE
const state = {
    Notification: {},
    Notifications: [],
    AllNotifications: [],
    NotificationsPagination: [],
}

// GETTERS
const getters = {
    Notification: state => state.Notification,
    Notifications: state => state.Notifications,
    AllNotifications: state => state.AllNotifications
}

// ACTIONS
const actions = {
    getNotifications({ commit }, params) {
        return new Promise((resolve, reject) => {
            notificationAPI.getNotifications(notifications => {
                commit(types.RECEIVE_NOTIFICATIONS, { notifications })
                resolve()
            }, params)
        })
    },
    getAllNotifications({ commit }, params) {
        return new Promise((resolve, reject) => {
            notificationAPI.getAllNotifications(notifications => {
                commit(types.RECEIVE_ALL_NOTIFICATIONS, { notifications })
                resolve()
            }, params)
        })
    },
    createNotification({ commit }, params) {
        return new Promise((resolve, reject) => {
            notificationAPI.createNotification(notification => {
                resolve(notification)
            }, params)
        })
    },
    getNotification({ commit }, id) {
        return new Promise((resolve, reject) => {
            notificationAPI.getNotification(notification => {
                commit(types.RECEIVE_NOTIFICATION, { notification })
                resolve()
            }, id)
        })
    },
    updateNotification({ commit }, params) {
        return new Promise((resolve, reject) => {
            notificationAPI.updateNotification(notification => {
                resolve(notification)
            }, params)
        })
    }
}

// MUTATIONS
const mutations = {
    [types.RECEIVE_NOTIFICATIONS] (state, { notifications }) {
        state.Notifications = notifications
    },
    [types.RECEIVE_ALL_NOTIFICATIONS] (state, { notifications }) {
        state.AllNotifications = notifications.Notifications;
        state.NotificationsPagination = {
            PageStartIndex: notifications.PageStartIndex,
            PageEndIndex: notifications.PageEndIndex,
            Pages: notifications.Pages,
            TotalCount: notifications.TotalCount,
            PageCount: notifications.PageCount
        }
    },
    [types.RECEIVE_NOTIFICATION] (state, { notification }) {
        state.Notification = notification
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
  


// WEBPACK FOOTER //
// ./src/store/modules/Notification.js